import { Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { PolicyGroups } from 'shared/utils/policy-controller';
import { PartnerAuthenticatedElement } from 'partner/shared/components/partner-authenticated-element/partner-authenticated-element';

type SidebarPartnerNameProps = {
  isSidebarOpen: boolean;
  partnerName: string;
};

export const SidebarPartnerName = (props: SidebarPartnerNameProps) => {
  const { isSidebarOpen, partnerName } = props;

  return isSidebarOpen ? (
    <PartnerAuthenticatedElement roles={'PARTNER'} policyGroup={PolicyGroups.PARTNER}>
      <StyledCompanyInfoBox>
        <StyledCompanyName variant="body1">{partnerName}</StyledCompanyName>
      </StyledCompanyInfoBox>
    </PartnerAuthenticatedElement>
  ) : null;
};

const StyledCompanyInfoBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textOverflow: 'ellipsis',
  textAlign: 'center',
}));

const StyledCompanyName = styled(Typography)(() => ({
  overflow: 'hidden',
}));
